var _path, _g, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 48.5685 48.5685 62 32 62C15.4315 62 2 48.5685 2 32C2 15.4315 15.4315 2 32 2C48.5685 2 62 15.4315 62 32Z",
    fill: "#77B3D4",
    stroke: "white",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0002 32.4501C49.0002 24.0351 41.3502 17.1501 32.0002 17.1501C22.6502 17.1501 15.0002 24.0351 15.0002 32.4501C15.0002 40.6101 22.0552 47.2401 30.9802 47.6651C31.5752 50.8101 32.0002 52.8501 32.0002 52.8501C32.0002 52.8501 36.2502 50.3001 40.1602 45.8801C45.4302 43.2451 49.0002 38.2301 49.0002 32.4501Z",
    fill: "#231F20"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5714 29.4C46.5714 42.2571 32 51 32 51C32 51 23.9429 15 32 15C40.0572 15 46.5714 21.4286 46.5714 29.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 45.8571C41.4674 45.8571 49.1425 38.9495 49.1425 30.4286C49.1425 21.9076 41.4674 15 31.9997 15C22.5319 15 14.8568 21.9076 14.8568 30.4286C14.8568 38.9495 22.5319 45.8571 31.9997 45.8571Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 32.1428C32.9463 32.1428 33.7138 31.3753 33.7138 30.4285C33.7138 29.4817 32.9463 28.7142 31.9996 28.7142C31.0528 28.7142 30.2853 29.4817 30.2853 30.4285C30.2853 31.3753 31.0528 32.1428 31.9996 32.1428Z",
    fill: "#4F5D73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8575 32.1428C39.8042 32.1428 40.5718 31.3753 40.5718 30.4285C40.5718 29.4817 39.8042 28.7142 38.8575 28.7142C37.9107 28.7142 37.1432 29.4817 37.1432 30.4285C37.1432 31.3753 37.9107 32.1428 38.8575 32.1428Z",
    fill: "#4F5D73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1429 32.1429C26.0896 32.1429 26.8572 31.3754 26.8572 30.4286C26.8572 29.4818 26.0896 28.7143 25.1429 28.7143C24.1961 28.7143 23.4286 29.4818 23.4286 30.4286C23.4286 31.3754 24.1961 32.1429 25.1429 32.1429Z",
    fill: "#4F5D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.80743649b1e99e304e785cddc6f537d6.svg";
export { ForwardRef as ReactComponent };